<script>
import UserService from "@/helpers/APIService/user.service";
import { required } from "vuelidate/lib/validators";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import simplebar from "simplebar-vue";
import appConfig from "@/app.config";
import moment from "moment";

/**
 * Chat Component
 */
export default {
  page: {
    title: "Booking",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    simplebar,
  },
  props: {
    currentProps: Object,
  },
  computed: {
    ...authComputed,
  },
  data() {
    return {
      chatData: [],
      chatMessagesData: [],
      title: "Chat",
      submitted: false,
      form: {
        message: null,
        image: [],
      },
      username: "",
      errorData: "",
    };
  },
  validations: {
    form: {
      message: {
        required,
      },
    },
  },
  mounted() {
    this.getGuestSMSList();
    var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 800, behavior: "smooth" });
  },
  methods: {
    chatUsername(name, id) {
      this.chatMessagesData = [];
      this.username = name;
      UserService.getSingleGuestSMS(id)
        .then((response) => {
          this.mobile_number = response[0].mobile;
          this.mobile_number_iso = response[0].mobile_iso;
          response[0].sms_messages.map((data) => {
            this.chatMessagesData.push({
              id: data.id,
              message: data.message_text,
              image: data.message_media_ulrs,
              msg_type: data.msg_type,
              userName: data.user_name,
              is_read: data.is_read,
              is_deliverd: data.is_deliverd,
              is_staff_msg: data.is_staff_msg,
              to_number: data.to_number,
              from_number: data.from_number,
              align: data.is_staff_msg ? "right" : "",
              date_time: moment(data.created_at).format("MMM-DD-YYYY HH:mm"),
            });
            if (data.is_read == false) {
              UserService.updateSMSReadStatus(data.id, { is_read: true });
            }
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
      var container2 = document.querySelector(
        "#containerElement .simplebar-content-wrapper"
      );
      container2.scrollTo({ top: 800, behavior: "smooth" });
    },
    uploadImages(event) {
      Object.keys(event.target.files).map((file) => {
        this.form.image.push(event.target.files[file]);
      });
    },
    formSubmit(e) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
          msg_type: "outbound",
          to_number: this.mobile_number,
          to_number_iso: this.mobile_number_iso,
          user_name: this.username,
        };
        if (this.form.message !== null) {
          data = { ...data, message_text: this.form.message };
        }

        const smsData = new FormData();
        Object.keys(data).map((key) => {
          smsData.append(key, data[key]);
        });
        if (this.form.image.length !== 0) {
          this.form.image.map((image) => {
            smsData.append("upload_media", image);
          });
        }
        UserService.sendSMS(smsData)
          .then((response) => {
            this.chatMessagesData.push({
              id: response.id,
              message: response.message_text,
              image: response.message_media_ulrs,
              msg_type: response.msg_type,
              userName: response.user_name,
              is_read: response.is_read,
              is_staff_msg: response.is_staff_msg,
              is_deliverd: response.is_deliverd,
              to_number: response.to_number,
              from_number: response.from_number,
              align: response.is_staff_msg ? "right" : "",
              date_time: moment(response.created_at).format(
                "MMM-DD-YYYY HH:mm"
              ),
            });
          })
          .catch((error) => {
            errorHandler(error);
            this.errorData = error.response.data;
          });
        this.handleScroll();
      }
      this.submitted = false;
      this.form = {
        message: null,
        image: [],
      };
    },
    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 50);
      }
    },
    avatarGenerator(name) {
      Middleware.avatarGenerator(name);
    },
    getGuestSMSList() {
      UserService.getSMSListByBooking(this.currentProps.booking.id)
        .then((response) => {
          this.username = response[0].first_name + " " + response[0].last_name;
          this.mobile_number = response[0].mobile;
          this.mobile_number_iso = response[0].mobile_iso;
          response.map((item) => {
            this.chatData.push({
              id: item.id,
              image: item.selfie_image,
              name: item.first_name + " " + item.last_name,
            });
          });
          response[0].sms_messages.map((data) => {
            this.chatMessagesData.push({
              id: data.id,
              message: data.message_text,
              image: data.message_media_ulrs,
              msg_type: data.msg_type,
              userName: data.user_name,
              is_read: data.is_read,
              is_staff_msg: data.is_staff_msg,
              is_deliverd: data.is_deliverd,
              to_number: data.to_number,
              from_number: data.from_number,
              align: data.is_staff_msg ? "right" : "",
              date_time: moment(data.created_at).format("MMM-DD-YYYY HH:mm"),
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <b-tab>
    <template v-slot:title>
      <span class="d-inline-block d-sm-none">
        <i class="fas fa-home"></i>
      </span>
      <span class="d-none d-sm-inline-block">SMS</span>
    </template>
    <div class="row">
      <div class="col-md-1">
        <ul class="list-unstyled chat-list">
          <li
            class
            v-for="data of chatData"
            :key="data.id"
            @click="chatUsername(data.name, data.id)"
            :class="{ active: username == data.name }"
          >
            <a href="javascript: void(0);" class="user-list">
              <div class="d-flex">
                <div class="align-self-center" v-if="data.image">
                  <img
                    :src="`${data.image}`"
                    class="rounded-circle avatar-xs"
                    alt
                    v-b-popover.hover="data.name"
                  />
                </div>
                <div class="avatar-xs align-self-center" v-if="!data.image">
                  <span
                    class="avatar-title rounded-circle bg-soft bg-primary text-primary"
                    v-b-popover.hover="data.name"
                    >{{ data.name.charAt(0) }}</span
                  >
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-11">
        <div class="card mb-0">
          <div class="p-4 border-bottom">
            <div class="row">
              <div class="col-md-4 col-9">
                <h5 class="font-size-15 mb-0">{{ username }}</h5>
              </div>
              <template v-if="typeof errorData === 'array'">
                <span v-for="error in errorData" :key="error">
                  <p class="text-danger">{{ error }}</p>
                </span>
              </template>
              <p class="text-danger" v-if="errorData !== ''">{{ errorData }}</p>
            </div>
          </div>
          <div class="chat-users">
            <div class="chat-conversation p-3">
              <simplebar id="containerElement" ref="current">
                <ul class="list-unstyled">
                  <li
                    v-for="data of chatMessagesData"
                    :key="data.id"
                    :class="{
                      right: data.msg_type === 'outbound' ? 'left' : 'right',
                    }"
                  >
                    <div class="conversation-list w-75">
                      <div class="conversation-list me-3">
                        <div class="ctext-wrap">
                          <div class="conversation-name">
                            {{ data.userName }}
                          </div>
                          <p v-if="data.message !== null || ''">
                            {{ data.message }}
                          </p>
                          <template v-if="data.image.length !== 0">
                            <span
                              v-for="(item, index) in data.image"
                              :key="index"
                            >
                              <img :src="item" alt="sms_image" srcset="" />
                            </span>
                          </template>
                          <p class="chat-time mb-0">
                            <i class="bx bx-time-five align-middle me-1"></i>
                            {{ data.date_time }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <h5
                  v-if="chatMessagesData.length == 0"
                  class="d-flex justify-content-center"
                >
                  You can start conversation here
                </h5>
              </simplebar>
            </div>
            <div class="p-3 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input
                      type="text"
                      autocomplete="off"
                      v-model="form.message"
                      class="form-control chat-input rounded"
                      placeholder="Enter Message..."
                      :class="{
                        'is-invalid': submitted && $v.form.message.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.message.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.message.required"
                        >This value is required.</span
                      >
                    </div>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <label
                            for="file"
                            v-b-tooltip.hover
                            placement="top"
                            title="Add Files"
                            class="text-primary fs-4 mb-0"
                          >
                            <i class="mdi mdi-file-document-outline"></i>

                            <input
                              type="file"
                              :src="form.image"
                              id="file"
                              class="d-none"
                              name="image"
                              accept="image/gif,image/jpeg,image/jpg,image/png"
                              multiple=""
                              data-original-title="upload photos"
                              @change="uploadImages($event)"
                            />
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    type="submit"
                    class="btn btn-primary btn-rounded chat-send w-md"
                  >
                    <span class="d-none d-sm-inline-block me-2">Send</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-tab>
</template>
<style scoped>
#containerElement {
  min-height: 100%;
}
.user-list {
  justify-content: center;
  display: flex;
}
.chat-conversation {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.chat-users .chat-conversation {
  height: calc(100vh - 340px);
}
</style>
